var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 45,
    height: 31,
    viewBox: "0 0 106.41 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo",
    fill: "#51289D",
    d: "M73.98,32.07c-6.9,0-13.48,2.14-19.05,6.2l-17.68-13.28c.62-1.91,.94-3.89,.94-5.89C38.19,8.57,29.62,0,19.1,0S0,8.57,0,19.1s8.57,19.1,19.1,19.1c4.17,0,8.12-1.33,11.45-3.83l16.36,12.3c-3.5,5.3-5.36,11.47-5.36,17.84s1.85,12.53,5.36,17.84l-16.36,12.3c-3.33-2.5-7.28-3.83-11.45-3.83-10.53,0-19.1,8.57-19.1,19.1s8.57,19.1,19.1,19.1,19.1-8.57,19.1-19.1c0-2.01-.32-3.99-.94-5.89l17.68-13.28c5.57,4.06,12.16,6.2,19.05,6.2,17.88,0,32.43-14.55,32.43-32.43s-14.55-32.43-32.43-32.43Zm0,53.34c-11.52,0-20.91-9.38-20.91-20.91s9.38-20.91,20.91-20.91,20.91,9.37,20.91,20.9-9.37,20.91-20.91,20.91ZM26.67,19.1c0,4.17-3.4,7.57-7.57,7.57s-7.57-3.4-7.57-7.57,3.4-7.57,7.57-7.57,7.57,3.4,7.57,7.57Zm0,90.82c0,4.17-3.4,7.57-7.57,7.57s-7.57-3.4-7.57-7.57,3.4-7.57,7.57-7.57,7.57,3.4,7.57,7.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleLogo);
export default __webpack_public_path__ + "static/media/dele-logo.bfa96bc7.svg";
export { ForwardRef as ReactComponent };